

export default {
  name: "ScoringModal",
}
